import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface FeatureFlagsState {
  excludeWeeklyPlans?: boolean;
}

const initialState: FeatureFlagsState = {};

export const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    setExcludeWeeklyPlans(state, action: PayloadAction<boolean>) {
      state.excludeWeeklyPlans = action.payload;
    },
  },
});

export const { setExcludeWeeklyPlans } = featureFlagsSlice.actions;
